import { useMemo, memo, lazy, Suspense } from "react";
import Header from "@/components/Header";
import PromoBanner from "@/components/PromoBanner";
import HomepageRenderer from "@/components/homepage/HomepageRenderer";
import LazySection from "@/components/LazySection";
import { useSearchParams } from "react-router-dom";
import JsonLdSchema from "@/components/JsonLdSchema";

const Footer = lazy(() => import("@/components/Footer"));

const Index = memo(() => {
  const [searchParams] = useSearchParams();
  const previewDesignId = useMemo(
    () => searchParams.get("preview_design") ? parseInt(searchParams.get("preview_design")!, 10) : null,
    [searchParams]
  );

  return (
    <main className="min-h-screen bg-background scroll-smooth">
      <JsonLdSchema type="organization" />
      <PromoBanner />
      <Header />
      <HomepageRenderer previewDesignId={previewDesignId} />
      <LazySection height="320px" rootMargin="100px">
        <Suspense fallback={null}>
          <Footer />
        </Suspense>
      </LazySection>
    </main>
  );
});

Index.displayName = "Index";

export default Index;
